import { ERROR_MESSAGES } from "../../constant/constant";
import { TENANT_DOMAIN } from "../../utils/domain";
import { useState } from "react";
import axios from "axios";

export const useTenantForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /**
   * @description
   * Function to send the password reset link to the user's email
   * @param {Object} param
   * @param {string} param.email
   * @param {string} param.subdomain
   * @param {function} param.onSuccess
   */
  const forgotPassword = async ({ email, subdomain, onSuccess }) => {
    setLoading(true);
    setError("");
    try {
      await axios.post(`${TENANT_DOMAIN}/tenant/auth/forget-password`, {
        email,
        subdomain,
      });
      onSuccess();
    } catch (err) {
      let firstErrorMessage = "";
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(
          firstErrorMessage ||
            err?.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    setError,
    setLoading,
    forgotPassword,
  };
};
